module.exports = __webpack_public_path__ + "static/media/Performance.4a8c5bb5.md";